package top.wcpe.allincore.ui.runtime.theme

import kotlin.math.PI

/**
 * Slot 控件主题令牌（ADR-0048 内部分组）。
 *
 * 由 [ControlTheme] 内部持有，`ControlTheme` 的 `slotXxx` accessor 委托至此——签名不变、消费者零改动。
 * 字段名去 `slot` 前缀。字段顺序与原 `ControlTheme` 主构造一致（视觉块 + 几何/状态块），默认值同原 `Builder`。
 *
 * 默认值为主题设计数值（颜色 / 透明度 / 尺寸），字面量即语义，故本文件按 detekt 配置豁免 MagicNumber。
 */
data class SlotTokens(
    // 视觉块
    val hoverColor: Int = 0x80FFFFFF.toInt(),
    val placeholderInset: Float = 1f,
    val rejectedShakeAmplitude: Float = 2f,
    val rejectedShakeFrequency: Float = (PI * 6.0).toFloat(),
    val failedMaxAlpha: Float = 0.5f,
    val failedColor: Int = 0xFFFF3030.toInt(),
    val successMaxAlpha: Float = 0.4f,
    val successColor: Int = 0xFF55C266.toInt(),
    val timeoutMaxAlpha: Float = 0.4f,
    val timeoutColor: Int = 0xFF808080.toInt(),
    val quickCraftPreviewAlpha: Float = 0.7f,
    val rejectedReplayAlpha: Float = 0.6f,
    // 几何 / 状态块
    val borderColor: Int = 0x00000000,
    val borderWidth: Float = 0f,
    val cornerRadius: Float = 0f,
    val selectedOutlineColor: Int = 0xFFFFD54F.toInt(),
    val selectedOutlineWidth: Float = 1f,
    val pressedOpacity: Float = 0.10f,
    val focusOpacity: Float = 0.10f,
    val disabledOpacity: Float = 0.38f,
    val hoverOpacity: Float = 0.08f,
    val focusOverlayColor: Int = 0x80FFFFFF.toInt(),
    val disabledOverlayColor: Int = 0x80000000.toInt(),
    val backgroundOuterColor: Int = 0xFF8B8B8B.toInt(),
    val backgroundInnerColor: Int = 0xFF373737.toInt(),
)
